import { combineReducers, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";

import storage from "redux-persist/lib/storage";

import data from "./core-module/data/reducers";
import services from "./core-module/services/reducers";

const rootReducer = combineReducers({
  data: data,
  services: services
});

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["data"]
};

export const persistanceOn = true;

const pReducer = persistanceOn
  ? persistReducer(persistConfig, rootReducer)
  : rootReducer;

const store =
  process.env.NODE_ENV === "development"
    ? createStore(pReducer, composeWithDevTools())
    : createStore(pReducer);

export const persistor = persistanceOn ? persistStore(store) : null;

export default store;

/*










import { createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { composeWithDevTools } from "redux-devtools-extension";

const formInitialState = {
  signupclass: "",
  areaid: "",
  accountType: "",
  firstName1: "",
  lastName1: "",
  firstName2: "",
  lastName2: "",
  mailingAddress: "",
  mailingAddress2: "",
  town: "",
  regionid: "",
  postalCode: "",
  serviceAddressSameAsMailing: false,
  serviceAddress: "",
  legalLandDescription: "",
  ats_quarter: " ",
  ats_section: " ",
  ats_township: " ",
  ats_range: " ",
  ats_meridian: " ",
  emailAddress: "",
  phoneType1: "",
  phoneNumber1: "",
  phoneExt1: "",
  phoneType2: "",
  phoneNumber2: "",
  phoneExt2: "",
  phoneType3: "",
  phoneNumber3: "",
  phoneExt3: "",
  phoneType4: "",
  phoneNumber4: "",
  phoneExt4: "",
  phoneType5: "",
  phoneNumber5: "",
  phoneExt5: "",
  additionalPhones: 0,
  advSrc: "",
  advSrcText: "",
  specialNotes: "",
  promoCode: "",
  lat: 0,
  lng: 0,
  recaptcha: ""
};

const rootPersistConfig = {
  key: "root",
  storage: storage
};

const dataPersistConfig = {
  key: "data",
  storage: storage
};

const servicesPersistConfig = {
  key: "services",
  storage: storage
};

const dataReducer = (state = formInitialState, action) => {
  switch (action.type) {
    case "FORM":
      return {
        ...state,
        [action.key]: action.value
      };
    case "FLUSH":
      return {
        ...formInitialState
      };
    default:
      return state;
  }
};

const servicesReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD":
      return {
        ...state,
        [action.key]: action.value
      };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  data: persistReducer(dataPersistConfig, dataReducer),
  services: persistReducer(servicesPersistConfig, servicesReducer)
});



const pReducer = persistReducer(rootPersistConfig, rootReducer);
const store = createStore(pReducer, composeWithDevTools());

export const persistor = persistStore(store);
export default store;


*/
